import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function CornerGraphic({ fullPageView }) {
  const styles = useStyles();
  const graphicClasses = cn(styles.graphic, { [styles.fullGraphic]: fullPageView });
  const ellipseClasses = cn(styles.ellipse, { [styles.fullGraphicEllipse]: fullPageView });

  return (
    <svg className={graphicClasses} xmlns="http://www.w3.org/2000/svg" width="804" height="716" viewBox="0 0 804 716">
      <g id="Group_8666" data-name="Group 8666" transform="translate(298 -705.031)">
        <g id="Ellipse_1500" data-name="Ellipse 1500" transform="translate(-92 779.031)" fill="none" className={ellipseClasses} strokeWidth="30" opacity="0.5">
          <circle cx="299" cy="299" r="299" stroke="none" />
          <circle cx="299" cy="299" r="284" fill="none" />
        </g>
        <g id="Ellipse_1502" data-name="Ellipse 1502" transform="translate(-213 805.031)" fill="none" className={ellipseClasses} strokeWidth="30" opacity="0.5">
          <circle cx="299" cy="299" r="299" stroke="none" />
          <circle cx="299" cy="299" r="284" fill="none" />
        </g>
        <g id="Ellipse_1501" data-name="Ellipse 1501" transform="translate(-298 705.031)" fill="none" className={ellipseClasses} strokeWidth="30">
          <circle cx="358" cy="358" r="358" stroke="none" />
          <circle cx="358" cy="358" r="343" fill="none" />
        </g>
      </g>
    </svg>
  );
}

CornerGraphic.propTypes = {
  fullPageView: PropTypes.bool,
};

CornerGraphic.defaultProps = {
  fullPageView: false,
};

export default CornerGraphic;
